import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'breakLine',
  pure: false,
  standalone: true,
})
export class BreakLinePipe implements PipeTransform {
  transform(value: string): any {
    return value.replace(/\n/g, '<br>');
  }
}
